// Attention, mettre des images au format png pour woosmap
import pictoStorelocEasybox from "@/assets/images/picto-storeloc-easybox.png";
import pictoStorelocEasyboxSelected from "@/assets/images/picto-storeloc-easybox-selected.png";
import pictoStorelocLaposte from "@/assets/images/picto-storeloc-laposte.png";
import pictoStorelocLaposteSelected from "@/assets/images/picto-storeloc-laposte-selected.png";
import pictoStorelocDelipop from "@/assets/images/picto-storeloc-delipop.png";
import pictoShippingDelipop from "@/assets/images/livraison/shipping-prc-delipop.png";
import pictoStorelocCev from "@/assets/images/picto-storeloc-cev.png";
import pictoStorelocCevSelected from "@/assets/images/picto-storeloc-cev-selected.png";
import placeholderCora from "@/assets/images/placeholder-cora.png";
import placeholderCoraSelectionne from "@/assets/images/placeholder-cora-selectionne.png";
import pictoStorelocRetrait from "@/assets/images/picto-storeloc-retrait.png";
import pictoStorelocRetraitSelectionne from "@/assets/images/picto-storeloc-retrait-selectionne.png";
import placeholderCarrefour from "@/assets/images/placeholder-carrefour.png";
import pinR from "@/assets/images/pin-r.png";
import { getDriveLink, getOneLink } from "@/utils/link-carrefour";

export const storeLocatorProps = () => ({
  isOneLink: {
    type: Boolean,
    required: false,
    default: false
  },
  themeColor: {
    type: String,
    required: false,
    default: "#5AA9DF"
  },
  shopId: {
    type: Number,
    required: false,
    default: null
  },
  zoomParams: {
    type: Object,
    required: false,
    default: null
  },
  magasins: {
    type: Array,
    required: false,
    default: () => []
  }
});

export const storeLocatorEmits = () => ["chooseShopClicked"];

export const useStoreLocator = (props, context) => {
  const storeLocatorHeight = ref(600);
  const isLegendShown = ref(false);
  const woosmapKey = useRuntimeConfig().public.WOOSMAP_KEY;

  const storeStyleHeight = computed(() => {
    return {
      height: storeLocatorHeight.value + "px"
    };
  });

  /* eslint-disable */
  const initWoosmapScript = (isOneLink) => {
    return new Promise((resolve) => {
      // Fix compatibilité map
      const mapSdk = document.getElementById("woosmap-map");
      if (mapSdk) {
        mapSdk.remove();
      }
      const script = document.createElement("script");
      script.setAttribute("src", "//webapp.woosmap.com/webapp.js");
      script.setAttribute("id", "woosmap-script");
      script.setAttribute("class", "optanon-category-C0001");
      document.head.appendChild(script);

      const convertTime = (UNIX_timestamp) => {
        let date = new Date(UNIX_timestamp * 1000);
        const months = [
          "Janv",
          "Fev",
          "Mar",
          "Avr",
          "Mai",
          "Juin",
          "Juill",
          "Août",
          "Sept",
          "Oct",
          "Nov",
          "Dec"
        ];
        var time =
          date.getDate() +
          " " +
          months[date.getMonth()] +
          " " +
          date.getFullYear();
        return time;
      };

      const getShopType = (store) => {
        let shopType = "";
        let shopTypeImage = "";
        if (store.properties.types[0] === "Magasin CRF") {
          shopTypeImage = placeholderCarrefour;
          shopType = "Magasin Carrefour";
        } else if (store.properties.types[0] === "Magasin STANDARD") {
          shopTypeImage = placeholderCora;
          shopType = "Magasin";
        } else if (store.properties.types[0] === "CEV") {
          shopTypeImage = pictoStorelocCev;
          shopType = "Cora en ville";
        } else if (store.properties.types[0] === "PRC") {
          shopTypeImage = pictoStorelocEasybox;
          shopType = "Easybox";
        } else if (store.properties.types[0] === "PRC_DELIPOP") {
          shopTypeImage = pictoShippingDelipop;
          shopType = "Delipop";
        } else if (store.properties.types[0] === "PRP_LA_POSTE") {
          shopTypeImage = pictoStorelocLaposte;
          shopType =
            "Point de retrait rattaché à : " +
            store.properties.user_properties.name_magasin;
        } else if (store.properties.user_properties) {
          shopTypeImage = pinR;
          shopType =
            "Point de retrait rattaché à : " +
            store.properties.user_properties.name_magasin;
        }
        return (
          "<div id='store-type' class='c-storelocator__name'><img src='" +
          shopTypeImage +
          "'><p>" +
          shopType +
          "</p></div>"
        );
      };

      const getSummaryShopType = (store) => {
        let shopType = "";
        if (store.properties.types[0] === "Magasin CRF") {
          shopType = "Magasin Carrefour";
        } else if (store.properties.types[0] === "Magasin STANDARD") {
          shopType = "Magasin";
        } else if (store.properties.types[0] === "CEV") {
          shopType = "Cora en ville";
        } else if (store.properties.types[0] === "PRC") {
          shopType = "Easybox";
        } else if (store.properties.types[0] === "PRC_DELIPOP") {
          shopType = "Delipop";
        } else if (store.properties.user_properties) {
          shopType =
            "Point de retrait rattaché à : " +
            store.properties.user_properties.name_magasin;
        }
        return (
          "<div id='store-type' class='c-storelocator__type'><p>" +
          shopType +
          "</p></div>"
        );
      };

      const getShopName = (store) => {
        if (store.properties.name) {
          let shopTypeImage = "";
          if (store.properties.types[0] === "Magasin CRF") {
            shopTypeImage = placeholderCarrefour;
          } else if (store.properties.types[0] === "Magasin STANDARD") {
            shopTypeImage = placeholderCora;
          } else if (store.properties.types[0] === "CEV") {
            shopTypeImage = pictoStorelocCev;
          } else if (store.properties.types[0] === "PRC") {
            shopTypeImage = pictoStorelocEasybox;
          } else if (store.properties.types[0] === "PRC") {
            shopTypeImage = pictoStorelocDelipop;
          } else if (store.properties.types[0] === "PRP_LA_POSTE") {
            shopTypeImage = pictoStorelocLaposte;
          } else {
            shopTypeImage = pinR;
          }
          return (
            "<div id='store-name' class='c-storelocator__name'><img src='" +
            shopTypeImage +
            "'><p>" +
            store.properties.name +
            "</p></div>"
          );
        }
      };

      const getAddress = (store) => {
        const address =
          store.properties.address.lines +
          (store.properties.address.zipcode
            ? ", " + store.properties.address.zipcode
            : "") +
          (store.properties.address.city
            ? " " + store.properties.address.city
            : "");
        return (
          "<div id='store-address' class='c-storelocator__address'><Icon name='map'></Icon><p>" +
          address +
          "</p></div>"
        );
      };

      const getOpeningLabel = (store) => {
        let openLabel = "";
        let classOpeningLabel = "";
        if (store.properties.open) {
          if (store.properties.open.open_now) {
            classOpeningLabel = "c-storelocator__opened";
            openLabel =
              "Ouvert aujourd’hui de " +
              store.properties.open.current_slice.start +
              " à " +
              store.properties.open.current_slice.end;
          } else {
            classOpeningLabel = "c-storelocator__closed";
            openLabel +=
              "Fermé jusqu'au " +
              convertTime(
                Date.parse(store.properties.open.next_opening.day) / 1000
              ) +
              " à " +
              store.properties.open.next_opening.start;
          }
          return (
            "<div class='" + classOpeningLabel + "'>" + openLabel + "</div>"
          );
        }
      };

      const getPhone = (store) => {
        if (store.properties.contact && store.properties.contact.phone) {
          return (
            "<div id='store-phone' class='c-storelocator__phone'><Icon name='phone'></Icon><p>" +
            store.properties.contact.phone +
            "</p></div>"
          );
        }
      };

      const getDistance = (store) => {
        if (store.properties.distance) {
          const distanceLabel = (store.properties.distance / 1000).toFixed(1);
          return (
            "<div class='c-storelocator__distance'>À " +
            distanceLabel +
            " Km</div>"
          );
        }
      };

      const getFullSchedule = (store) => {
        if (store.properties.weekly_opening) {
          const weeklyOpening = store.properties.weekly_opening;
          const dayLabels = {
            1: "Lundi",
            2: "Mardi",
            3: "Mercredi",
            4: "Jeudi",
            5: "Vendredi",
            6: "Samedi",
            7: "Dimanche"
          };
          let daysHoursHTMLTable = "";
          if (weeklyOpening) {
            for (const day in dayLabels) {
              let daysHours = "";
              if (weeklyOpening[day].hours.length === 0) {
                daysHours = "Fermé";
              } else {
                weeklyOpening[day].hours.some((hour, idx) => {
                  if (hour && hour["all-day"]) {
                    daysHours = "24h/24";
                    return true;
                  } else if (daysHours.length > 0) {
                    hour.start === "00:00" && hour.end === "00:00"
                      ? (daysHours += ", Fermé")
                      : (daysHours += ", " + hour.start + "-" + hour.end);
                  } else {
                    hour.start === "00:00" && hour.end === "00:00"
                      ? (daysHours = "Fermé")
                      : (daysHours = hour.start + "-" + hour.end);
                  }
                });
              }
              daysHoursHTMLTable +=
                "<tr>" +
                "<td class='padding-right'>" +
                dayLabels[day] +
                "</td>" +
                "<td>" +
                daysHours +
                "</td>" +
                "</tr>";
            }
          }
          return (
            "<div id='store-schedule' class='c-storelocator__schedule'><p>Horaires</p><table>" +
            daysHoursHTMLTable +
            "</table></div>"
          );
        }
      };

      const getSetShop = (store) => {
        if (store.properties.types[0] === "Magasin CRF") {
          const magasin = props.magasins.find(
            (mag) => mag.id === store.properties.store_id
          );
          let url = "https://www.carrefour.fr";
          if (magasin) {
            if (isOneLink) {
              url = getOneLink(magasin);
            } else {
              url = getDriveLink(magasin);
            }
          }
          return (
            "<a href='" +
            url +
            "'' target='_blank' class='c-storelocator__set-shop'>Faire mes courses sur carrefour.fr</a>"
          );
        } else if (store.properties.store_id == props.shopId) {
          return "<div id='store-selected' class=''c-storelocator__selected'>Magasin sélectionné</div>";
        } else {
          return "<button type='button' id='set-shop' class='c-storelocator__set-shop'>Choisir ce magasin</button>";
        }
      };

      const getShopDetails = (store) => {
        if (store.properties.contact && store.properties.contact.website) {
          return (
            "<div id='store-website' class='c-storelocator__website'>" +
            "<Icon name='web'></Icon>" +
            "<a class='text-black' href='" +
            store.properties.contact.website +
            "'>Voir la fiche magasin</a>" +
            "</div>"
          );
        }
      };
      window.loadWebApp = () => {
        const webApp = new WebApp("store-locator", woosmapKey);

        webApp.setFullStoreRenderer((store) => {
          const myCustomContent = document.createElement("div");
          myCustomContent.id = "myCustomContentID";
          myCustomContent.className = "c-storelocator__detail";
          const html = [];
          html.push(getShopType(store));
          html.push(getAddress(store));
          html.push(getPhone(store));
          html.push(getDistance(store));
          html.push(getFullSchedule(store));
          html.push(getSetShop(store));

          if (store.properties.types[0] !== "Magasin CRF") {
            html.push(getShopDetails(store));
          }

          myCustomContent.innerHTML = html.join("");

          // event to choose shop
          const buttonSetShop = myCustomContent.querySelector("#set-shop");
          if (buttonSetShop) {
            buttonSetShop.onclick = (evt) => {
              let storeId = store.properties.store_id;
              const array = storeId.split("_");
              if (array[0] === "P") {
                storeId = array[1];
              }
              context.emit("chooseShopClicked", storeId);
            };
          }

          return myCustomContent;
        });

        webApp.setSummaryStoreRenderer((store) => {
          const mySummaryContent = document.createElement("div");
          mySummaryContent.className = "c-storelocator__summary";
          const html = [];
          html.push(getShopName(store));
          html.push(getSummaryShopType(store));
          html.push(getAddress(store));
          html.push(getOpeningLabel(store));
          html.push(getDistance(store));
          //html.push(getPhone(store));
          html.push(getSetShop(store));

          if (store.properties.types[0] !== "Magasin CRF") {
            html.push(getShopDetails(store));
          }

          mySummaryContent.innerHTML = html.join("");

          // event to choose shop
          const buttonSetShop = mySummaryContent.querySelector("#set-shop");
          if (buttonSetShop) {
            buttonSetShop.onclick = (evt) => {
              let storeId = store.properties.store_id;
              const array = storeId.split("_");
              if (array[0] === "P") {
                storeId = array[1];
              }
            };
          }

          return mySummaryContent;
        });

        const config = {
          theme: {
            primaryColor: props.themeColor
          },
          maps: {
            provider: "woosmap",
            apiKey: woosmapKey,
            localities: {
              language: "fr",
              componentRestrictions: { country: "fr" }
            },
            geocoder: {
              region: "fr"
            }
          },
          internationalization: {
            lang: "fr",
            period: "fr",
            unitSystem: 0
          },
          datasource: {
            maxResponses: 30,
            maxDistance: 30000, // in meters
            useDistanceMatrix: false
          },
          woosmapview: {
            initialZoom: props.zoomParams ? 11 : 6,
            breakPoint: 9,
            style: {
              default: {
                icon: {
                  url: pictoStorelocRetrait,
                  scaledSize: {
                    width: 40,
                    height: 40
                  }
                },
                selectedIcon: {
                  url: pictoStorelocRetraitSelectionne,
                  scaledSize: {
                    width: 53,
                    height: 53
                  }
                },
                numberedIcon: {
                  url: pictoStorelocRetrait,
                  scaledSize: {
                    width: 40,
                    height: 40
                  }
                }
              },
              rules: [
                {
                  type: "Magasin CRF",
                  icon: {
                    url: placeholderCarrefour,
                    scaledSize: {
                      width: 40,
                      height: 40
                    }
                  },
                  color: props.themeColor,
                  selectedIcon: {
                    url: placeholderCarrefour,
                    scaledSize: {
                      width: 51,
                      height: 51
                    }
                  },
                  numberedIcon: {
                    url: placeholderCarrefour,
                    scaledSize: {
                      width: 40,
                      height: 40
                    }
                  }
                },
                {
                  type: "Magasin STANDARD",
                  icon: {
                    url: placeholderCora,
                    scaledSize: {
                      width: 40,
                      height: 40
                    }
                  },
                  color: props.themeColor,
                  selectedIcon: {
                    url: placeholderCoraSelectionne,
                    scaledSize: {
                      width: 51,
                      height: 51
                    }
                  },
                  numberedIcon: {
                    url: placeholderCora,
                    scaledSize: {
                      width: 40,
                      height: 40
                    }
                  }
                },
                {
                  type: "CEV",
                  icon: {
                    url: pictoStorelocCev,
                    scaledSize: {
                      width: 40,
                      height: 40
                    }
                  },
                  color: props.themeColor,
                  selectedIcon: {
                    url: pictoStorelocCevSelected,
                    scaledSize: {
                      width: 51,
                      height: 51
                    }
                  },
                  numberedIcon: {
                    url: pictoStorelocCev,
                    scaledSize: {
                      width: 40,
                      height: 40
                    }
                  }
                },
                {
                  type: "PRC",
                  icon: {
                    url: pictoStorelocEasybox,
                    scaledSize: {
                      width: 40,
                      height: 40
                    }
                  },
                  color: props.themeColor,
                  selectedIcon: {
                    url: pictoStorelocEasyboxSelected,
                    scaledSize: {
                      width: 51,
                      height: 51
                    }
                  },
                  numberedIcon: {
                    url: pictoStorelocEasybox,
                    scaledSize: {
                      width: 40,
                      height: 40
                    }
                  }
                },
                {
                  type: "PRC_DELIPOP",
                  icon: {
                    url: pictoStorelocDelipop,
                    scaledSize: {
                      width: 40,
                      height: 40
                    }
                  },
                  color: props.themeColor,
                  selectedIcon: {
                    url: pictoStorelocDelipop,
                    scaledSize: {
                      width: 51,
                      height: 51
                    }
                  },
                  numberedIcon: {
                    url: pictoStorelocDelipop,
                    scaledSize: {
                      width: 40,
                      height: 40
                    }
                  }
                },
                {
                  type: "PRP_LA_POSTE",
                  icon: {
                    url: pictoStorelocLaposte,
                    scaledSize: {
                      width: 40,
                      height: 40
                    }
                  },
                  color: props.themeColor,
                  selectedIcon: {
                    url: pictoStorelocLaposteSelected,
                    scaledSize: {
                      width: 51,
                      height: 51
                    }
                  },
                  numberedIcon: {
                    url: pictoStorelocLaposte,
                    scaledSize: {
                      width: 40,
                      height: 40
                    }
                  }
                }
              ]
            }
          },
          filters: {
            filters: [
              {
                propertyType: "type",
                title: {
                  fr: "Types de magasins"
                },
                choices: [
                  {
                    key: "Magasin CRF",
                    fr: "Magasin Carrefour"
                  },
                  {
                    key: "Magasin STANDARD",
                    fr: "Hypermarchés"
                  },
                  {
                    key: "PRP",
                    fr: "Points de retrait"
                  },
                  {
                    key: "CEV",
                    fr: "Drives piéton"
                  },
                  {
                    key: "PRC",
                    fr: "Easybox"
                  }
                ],
                innerOperator: "or"
              }
            ]
          }
        };
        // center the map if customer is rattached
        if (props.zoomParams) {
          const woosmapview = {
            ...config.woosmapview,
            initialCenter: props.zoomParams
          };
          config.woosmapview = woosmapview;
        }

        webApp.setConf(config);
        var isMobile = document.querySelector("body").clientWidth < 900;
        webApp.setInitialStateToGeolocation();
        webApp.render(isMobile);
      };
      /* eslint-enable */
      script.addEventListener("load", () => {
        window.loadWebApp();
      });
    });
  };

  const beforeUnmount = () => {
    const slSdk = document.getElementById("woosmap-script");
    if (slSdk) {
      slSdk.remove();
    }
  };

  return {
    storeLocatorHeight,
    isLegendShown,
    woosmapKey,
    storeStyleHeight,
    initWoosmapScript,
    beforeUnmount
  };
};
